import { getMemberId } from './memberId.ts';

/**
 * Retrieves the current member ID, or falls back to `"me"` if the ID is nullish.
 * Unlike {@link getMemberId}, this function always returns a string.
 *
 * @returns The memberId or `"me"`
 */
export const getMemberIdWithFallback = (): string => {
  return getMemberId() ?? 'me';
};
